import { makeAutoObservable, computed } from 'mobx';
import { AvatarUserInterface } from '../../interfaces/WorkspaceInterface';
import { RawUser, userActivity } from '../interfaces/user';
import { rootStore } from '../rootStore';
import { groupMyTasksByFilter } from '../../services/mobxTaskFilterService';
import { DEFAULT_DATE_FORMAT } from '../../global/constants';
import { AiAgent } from '../interfaces/workspace';

export class UserModel {
  // Common
  id: string;
  email: string;
  name: string;
  avatar: AvatarUserInterface;
  isOwner?: boolean;
  isAdmin: boolean;
  phone: string | undefined;
  profile_photo: string | undefined;
  role?: number;
  lastSeen: string;
  customerCompanyName?: string;
  customerCompanyId?: string;

  dateFormat: string;
  deviceId: string | null;
  timeZone: string | null;
  userActivity: userActivity[] = [];
  access_token?: string;
  given_name?: string;
  device_id?: string;
  expires_in?: number;
  user_created_on?: number;

  constructor(rawUser: RawUser) {
    makeAutoObservable(this, {
      filteredTasks: computed,
    });

    this.id = rawUser.id;
    this.email = rawUser.email;
    this.name = rawUser.name;
    this.avatar = rawUser.avatar;
    this.isOwner = rawUser.isOwner;
    this.isAdmin = rawUser.isAdmin;
    this.phone = rawUser.phone;
    this.profile_photo = rawUser.profile_photo;
    this.role = rawUser.role;
    this.dateFormat = rawUser.dateFormat ?? DEFAULT_DATE_FORMAT;
    this.deviceId = rawUser.deviceId ?? null;
    this.timeZone = rawUser.timeZone ?? null;
    this.lastSeen = rawUser.lastSeen || '';
    this.customerCompanyName = rawUser.customerCompanyName;
    this.customerCompanyId = rawUser.customerCompanyId;
  }

  get tasks() {
    return rootStore.taskStore.tasks.filter((task) => task.usersIds.includes(this.id) && !task.status);
  }

  get filteredTasks() {
    return groupMyTasksByFilter(this.tasks, rootStore.taskStore.myTasksFilter);
  }

  setUserActivity(activityData: userActivity[]) {
    this.userActivity = activityData;
  }
}

export const createObservableUser = (rawUser: RawUser) => {
  return new UserModel(rawUser);
};

export const createObservableUserFromAiAgent = (aiAgent: AiAgent) => {
  const rawUser: RawUser = {
    id: aiAgent.id,
    email: '',
    name: aiAgent.name,
    avatar: {
      avatar: aiAgent.profile_photo,
      avatar_120: aiAgent.profile_photo
    },
    isAdmin: false,
    phone: undefined,
    profile_photo: aiAgent.profile_photo
  };

  return new UserModel(rawUser);
};
